// Non-value definitions.
export const setParams = [
    'answer',
    'assistiveListeningMute',
    'assistiveListeningVolume',
    'audioInputMute',
    'audioInputVolume',
    'call',
    'callLayout',
    'cameraMove',
    'cameraPosition',
    'cameraPreset',
    'cameraSelected',
    'cameraSelfView',
    'cameraSelfViewAuto',
    'cameraSelfViewPosition',
    'cameraTracking',
    'consentToRecording',
    'contactClosure',
    'contentSource',
    'dial',
    'displayBlank',
    'displayFreeze',
    'equipmentSetting',
    'hangup',
    'inviteToCall',
    'lightingLevel',
    'lightingPower',
    'lightingPreset',
    'mediaOperation',
    'mute',
    'muteParticipant',
    'muteParticipantVideo',
    'overflowRoomMute',
    'overflowRoomVolume',
    'power',
    'reboot',
    'receiveGain',
    'reject',
    'sendHostKey',
    'sendMeetingCode',
    'sendVideo',
    'shadeOperation',
    'shadePosition',
    'shadePreset',
    'shadeTilt',
    'soundReinforcementMute',
    'soundReinforcementVolume',
    'spotlightParticipant',
    'stopContent',
    'usbHost',
    'videoInput',
    'videoMatrixRoute',
    'volume',
    'volumeMute',
];
export function isSetParam(value) {
    return setParams.some(n => n === value);
}
export function assertIsSetParam(value) {
    if (!isSetParam(value))
        throw new Error('expected SetParam');
}
export const queryParams = [
    'assistiveListeningMute',
    'assistiveListeningVolume',
    'audioInputMute',
    'audioInputVolume',
    'busy',
    'calendar',
    'call',
    'callInList',
    'callParticipant',
    'callParticipants',
    'callStatus',
    'cameraMove',
    'cameraPosition',
    'cameraPreset',
    'cameraSelected',
    'cameraSelfView',
    'cameraSelfViewAuto',
    'cameraSelfViewAvailable',
    'cameraSelfViewPosition',
    'cameraTracking',
    'caps',
    'channel',
    'channelTuner',
    'closedCaptioning',
    'configDetected',
    'configValidated',
    'contactClosure',
    'contentSource',
    'contentState',
    'detected',
    'directory',
    'directoryEntry',
    'displayBlank',
    'displayFreeze',
    'equipmentInfo',
    'firmwareVersion',
    'hangup',
    'lampOperationTime',
    'lightingLevel',
    'lightingPower',
    'lightingPreset',
    'mediaPlayerState',
    'mediaRecorderStartTime',
    'mediaRecorderState',
    'mediaStreamerState',
    'mute',
    'name',
    'overflowRoomMute',
    'overflowRoomVolume',
    'power',
    'receiveGain',
    'serialNumber',
    'settings',
    'shadePosition',
    'shadePreset',
    'shadeTilt',
    'storage',
    'soundReinforcementMute',
    'soundReinforcementVolume',
    'usbHost',
    'validated',
    'videoInput',
    'videoMatrixRoute',
    'volume',
    'volumeMute',
];
export function isQueryParam(value) {
    return queryParams.some(n => n === value);
}
export function assertIsQueryParam(value) {
    if (!isQueryParam(value))
        throw new Error('expected QueryParam');
}
